export default __webpack_public_path__ + "static/nadi-network-e0afb076892c18d50cc682e15c76fd63.png";